<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" :md="colMd">
        <v-card 
          class="pa-6" 
          elevation="0"
          rounded="lg" 
          :style="{ 
            backgroundColor: backgroundColor,
            border: '1px solid rgba(0, 0, 0, 0.08)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
          }"
        >
            <slot />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: 'rgb(0, 0, 0)',
    },
    colMd: {
      type: [Number, String],
      default: 12,
    },
  }
};
</script>